import React, {Component} from 'react';
import strings from 'utils/strings';
import './styles.scss';

class AddNotesModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addNotes: false,
		};
	}

	handleYes = () => {
		this.setState({addNotes: true});
	};

	handleNo = () => {
		this.props.toggleModal();

		if (typeof this.props.onPrint === 'function') {
			this.props.onPrint();
			return;
		}

		window.print();
	};

	handleInputChange = (e) => {
		this.props.setReportNotes(e.target.value);
	};

	handlePrintWithNotes = () => {
		this.props.toggleModal();

		if (typeof this.props.onPrint === 'function') {
			this.props.onPrint();
			return;
		}

		window.print();
	};

	render() {
		const {addNotes} = this.state;
		const {reportNotes} = this.props;
		return (
			<div
				className="modal-overlay"
				onClick={() => {
					this.props.toggleModal();
				}}
			>
				<div className="lit-options-container">
					<div
						className="modal-content"
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						{!addNotes ? (
							<>
								<h3>{strings.testView.villLaggaTillAnteckningar}</h3>
								<div className="modal-buttons-div">
									<div className="lit-option-pane">
										<button
											style={{color: 'black'}}
											className="__approve"
											onClick={this.handleYes}
										>
											{strings.common.ja}
										</button>
									</div>

									<div className="lit-option-pane">
										<button
											className="__disprove"
											onClick={this.handleNo}
										>
											{strings.common.nei}{' '}
										</button>
									</div>
								</div>
							</>
						) : (
							<>
								<h3>{strings.testView.addnotes}</h3>
								<textarea
									className="notes-input"
									placeholder={strings.testView.skrivInDinaAnteckningar}
									value={reportNotes}
									onChange={this.handleInputChange}
								/>
								<div className="modal-buttons-div">
									<div className="modal-button">
										<button
											disabled={!reportNotes}
											className="btn-primary"
											onClick={this.handlePrintWithNotes}
										>
											{strings.testView.skrivUtMedAnteckningar}
										</button>
									</div>
									<div className="modal-button">
										<button
											className="btn-secondary"
											onClick={this.props.toggleModal}
										>
											{strings.common.cancel}
										</button>
									</div>
								</div>
							</>
						)}
					</div>
				</div>{' '}
			</div>
		);
	}
}

export default AddNotesModal;
